'use es6';

import styled from 'styled-components';
const FilterTag = styled.span.withConfig({
  displayName: "FilterTag",
  componentId: "n1yo8-0"
})(["span:hover{text-decoration:underline;}"]);
export default FilterTag;